import { render } from "./ShareDialog.vue?vue&type=template&id=6acb39b9&scoped=true"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"

import "./ShareDialog.vue?vue&type=style&index=0&id=6acb39b9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acb39b9"]])

export default __exports__